import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyEditRequestBody, PropertyEditResponse } from "./types";

export class PropertyEditAPI extends BaseAPI<
    PropertyEditRequestBody,
    PropertyEditResponse
> {
    protected route = ApiRoutes.property.edit;
    protected method = RequestMethod.PUT;
    protected hasFile = true;
    protected params = ["id"]; // Specify that 'id' is a URL parameter

    protected prepareRequest(data: FormData): RequestInit {
        return {
          method: this.method,
          body: data,
        };
      }
}